﻿// Get or set cookies
const cookie = {
    // Get the value of a cookie by its name
    get: name => document.cookie.split('; ').find(c => c.startsWith(name + '='))?.split('=')[1] || null,
    // Set a session-based cookie with a name and value
    set: (name, value) => document.cookie = `${name}=${value};path=/`
};

// Show the popup if the 'userTypePopupShown' cookie is not set
if (!cookie.get('userTypePopupShown')) {
    // Remove the 'hidden' class from the popup to make it visible
    document.getElementById('popupWrapper').classList.remove('hidden');
}

// Attach a click event listener to all buttons with the class 'user-type-btn'
document.querySelectorAll('.user-type-btn').forEach(btn =>
    btn.addEventListener('click', () => {
        // When a button is clicked, set the 'userTypePopupShown' cookie to 'true'
        cookie.set('userTypePopupShown', 'true');
        // Hide the popup by adding the 'hidden' class to the popup wrapper //
        document.getElementById('popupWrapper').classList.add('hidden');
    })
);
